import * as actions from "../actions/types";

const initialState = {
  tickets: [],
};

const ticketReducer = (state = initialState, action) => {
  switch (action.type) {
    case actions.TICKETS_LOADED_SUCCESS:
      return {
        ...state,
        tickets: action.payload,
      };
    default:
      return state;
  }
};

export default ticketReducer;
